import { jsx as _jsx } from "react/jsx-runtime";
import AppErrorPage from "../../../AppErrorPage";
import { useHistory } from "react-router-dom";
var Oops = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var _o = _a.refresh, refresh = _o === void 0 ? false : _o;
    var history = useHistory();
    return (_jsx(AppErrorPage, { pageError: {
            status: 500,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            message: (_d = (_c = (_b = history === null || history === void 0 ? void 0 : history.location) === null || _b === void 0 ? void 0 : _b.state) === null || _c === void 0 ? void 0 : _c.publicError) !== null && _d !== void 0 ? _d : (_f = (_e = window.history) === null || _e === void 0 ? void 0 : _e.state) === null || _f === void 0 ? void 0 : _f.publicError,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            error: (_m = (_j = (_h = (_g = history === null || history === void 0 ? void 0 : history.location) === null || _g === void 0 ? void 0 : _g.state) === null || _h === void 0 ? void 0 : _h.error) !== null && _j !== void 0 ? _j : (_l = (_k = window.history) === null || _k === void 0 ? void 0 : _k.state) === null || _l === void 0 ? void 0 : _l.error) !== null && _m !== void 0 ? _m : "Unknown Error",
        } }));
};
export default Oops;
